import { lazy } from 'react';
import { DashboardLayout } from '../../../app/components';
import { routingPath } from '../../../app/routes';
import { operationsRoutes } from 'routes/operations/OperationsRoutes';

const OperationsMain = lazy(() =>
  import('../pages/OperationsMain').then((m) => ({
    default: m.OperationsMain,
  })),
);

const OperationRoutes = () => {
  return {
    element: <DashboardLayout />,
    children: [
      ...operationsRoutes,
      {
        path: routingPath.operations.main,
        element: <OperationsMain />,
      },
    ],
  };
};

export default OperationRoutes;
